import { IMultiSelectOption } from 'components/Form/Select/MultiSelect';
import useFetchResource from 'hooks/useFetchResource';
import api from 'libs/api';
import { selectSerializer } from 'libs/serializers';

export interface IBuilding {
  id: number;
  prefix: string;
  address: string;
}

export type TBuildingOption = IBuilding & IMultiSelectOption;

export default function useGetBuildings(guid?: string) {
  const {
    resource: buildings,
    fetchResource: fetchBuildings,
    isLoading,
  } = useFetchResource<TBuildingOption[]>({
    api: api.account.buildings.public,
    initialValues: [],
    initialParams: { guid },
    serializer: (data) => selectSerializer(data.resources, { labelKey: 'prefix', valueKey: 'id' }),
  });

  return { buildings, fetchBuildings, isLoading };
}
